import type { PlainOrganizationMember } from "@/queries/organization-queries";
import type { PlainProject } from "@/queries/project-queries";
import { coalesce } from "@/utils/arrays";

/**
 * Returns a list of users associated with a project.
 * This list includes the project creator and org members that have existing environments created with this project.
 */
export const getProjectUsers = (project: PlainProject, orgMembers?: PlainOrganizationMember[]) => {
    if (!orgMembers) {
        return undefined;
    }

    const creator = orgMembers?.find((m) => m.userId === project.metadata?.creator?.id);
    let orgMemberUsers = coalesce(
        project.usedBy?.subjects?.map((s) => orgMembers?.find((m) => m.userId === s.id)) ?? [],
    );
    orgMemberUsers = orgMemberUsers.filter((u) => u.userId !== creator?.userId);

    const projectUsers = [];
    if (creator) {
        projectUsers.push(creator);
    }
    projectUsers.push(...orgMemberUsers);

    return projectUsers.slice(0, 5);
};
